import { defineMessages } from 'react-intl';

const messages = defineMessages({
  download96: {
    id: 'download96',
    defaultMessage: 'Download 96-well sequence template'
  },
  download384: {
    id: 'download384',
    defaultMessage: 'Download 384-well sequence template'
  }
});

export default messages;
